<div class="row">
    <div class="col-12">
        <ng-template [ngIf]="alertLineData.hasAlertPrimaryMessage">
            <div class="alert alert-primary" role="alert">
                {{alertLineData.alertPrimaryMessage}}
                <button type="button" class="close" data-dismiss="alert" aria-label="Fermer" (click)="alertLineData.resetAlertPrimaryMessage()"><span aria-hidden="true">&times;</span></button>
            </div>
        </ng-template>

        <ng-template [ngIf]="alertLineData.hasAlertSecondaryMessage">
            <div class="alert alert-secondary" role="alert">
                {{alertLineData.alertSecondaryMessage}}
                <button type="button" class="close" data-dismiss="alert" aria-label="Fermer" (click)="alertLineData.resetAlertSecondaryMessage()"><span aria-hidden="true">&times;</span></button>
            </div>
        </ng-template>

        <ng-template [ngIf]="alertLineData.hasAlertSuccessMessage">
            <div class="alert alert-success" role="alert">
                {{alertLineData.alertSuccessMessage}}
                <button type="button" class="close" data-dismiss="alert" aria-label="Fermer" (click)="alertLineData.resetAlertSuccessMessage()"><span aria-hidden="true">&times;</span></button>
            </div>
        </ng-template>

        <ng-template [ngIf]="alertLineData.hasAlertDangerMessage">
            <div class="alert alert-danger" role="alert">
                {{alertLineData.alertDangerMessage}}
                <button type="button" class="close" data-dismiss="alert" aria-label="Fermer" (click)="alertLineData.resetAlertDangerMessage()"><span aria-hidden="true">&times;</span></button>
            </div>
        </ng-template>

        <ng-template [ngIf]="alertLineData.hasAlertWarningMessage">
            <div class="alert alert-warning" role="alert">
                {{alertLineData.alertWarningMessage}}
                <button type="button" class="close" data-dismiss="alert" aria-label="Fermer" (click)="alertLineData.resetAlertWarningMessage()"><span aria-hidden="true">&times;</span></button>
            </div>
        </ng-template>

        <ng-template [ngIf]="alertLineData.hasAlertInfoMessage">
            <div class="alert alert-info" role="alert">
                {{alertLineData.alertInfoMessage}}
                <button type="button" class="close" data-dismiss="alert" aria-label="Fermer" (click)="alertLineData.resetAlertInfoMessage()"><span aria-hidden="true">&times;</span></button>
            </div>
        </ng-template>

        <ng-template [ngIf]="alertLineData.hasAlertLightMessage">
            <div class="alert alert-light" role="alert">
                {{alertLineData.alertLightMessage}}
                <button type="button" class="close" data-dismiss="alert" aria-label="Fermer" (click)="alertLineData.resetAlertLightMessage()"><span aria-hidden="true">&times;</span></button>
            </div>
        </ng-template>

        <ng-template [ngIf]="alertLineData.hasAlertDarkMessage">
            <div class="alert alert-dark" role="alert">
                {{alertLineData.alertDarkMessage}}
                <button type="button" class="close" data-dismiss="alert" aria-label="Fermer" (click)="alertLineData.resetAlertDarkMessage()"><span aria-hidden="true">&times;</span></button>
            </div>
        </ng-template>
    </div>
</div>
